export function fromLocalStorage<T>(key: string, parse: boolean): T;
export function fromLocalStorage<T>(key: string, parse?: boolean): string | null | T {
    const data = localStorage.getItem(key);

    if (!parse)
        return data;

    if (!data)
        return data;

    try {
        return JSON.parse(data);
    } catch (e) {
        return null;
    }
}

export function saveOnLocalStorage<T>(key: string, value: T): void {
    if (typeof value !== 'object')
        return localStorage.setItem(key, String(value));

    localStorage.setItem(key, JSON.stringify(value));
}
